<template>
  <div class="ql-editor ql-editor--display" :class="contentClass">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    contentClass: {
      type: String,
      default: ''
    }
  }
};
</script>
